import React from "react";
import { ColumnsType } from "antd/es/table";
import { TFunction } from "i18next";

import { getFormatDate } from "~/libs/getFormatDate";

export type ContractTemplateTableRow = {
  id: string;
  name: string;
  link: string;
  active: string;
  updatedAt: string;
  FileId?: string;
  File?: unknown;
  [key: string]: unknown;
};

type SortState = {
  sortField?: string;
  sortType?: "ASC" | "DESC";
};

export const getContractTemplatesColumns = (
  t: TFunction,
  sort: SortState,
): ColumnsType<ContractTemplateTableRow> => {
  const { sortField, sortType } = sort;

  return [
    {
      title: t("contractTemplates.table.name"),
      dataIndex: "name",
      key: "name",
    },
    {
      title: t("contractTemplates.table.link"),
      dataIndex: "link",
      key: "link",
      render: (href: string) =>
        href ? (
          <a href={href} target="_blank" rel="noopener noreferrer" download>
            Ссылка
          </a>
        ) : (
          ""
        ),
    },
    {
      title: t("contractTemplates.table.active"),
      dataIndex: "active",
      key: "active",
      sorter: true,
      sortOrder:
        sortField === "active" && sortType
          ? sortType === "ASC"
            ? "ascend"
            : "descend"
          : undefined,
    },
    {
      title: t("contractTemplates.table.updatedAt"),
      dataIndex: "updatedAt",
      key: "updatedAt",
      render: (value: string) => getFormatDate(value),
    },
  ];
};
